import React, { useState, useEffect } from "react";
import ReferenceModal from "../../approval/ReferenceModal";

export default function PeopleCell({
  value = [],
  onChange,
  placeholder = "담당자를 선택하세요",
  single = false,
}) {
  const [open, setOpen] = useState(false);
  const [tempSelectedIds, setTempSelectedIds] = useState([]);

  useEffect(() => {
    if (open) {
      setTempSelectedIds(value.map((v) => v.id));
    }
  }, [open, value]);

  const handleSave = (ids, userDetails) => {
    const mapped = userDetails.map((u) => ({
      id: u.id,
      name: u.name ?? `${u.last_name ?? ""}${u.first_name ?? ""}`,
    }));
    onChange(mapped);
    setOpen(false);
    return true;
  };

  const removePerson = (id) => {
    const nextValue = value.filter((p) => p.id !== id);
    onChange(nextValue);
    setTempSelectedIds(nextValue.map((p) => p.id));
  };

  return (
    <div className="w-full">

      {/* 선택된 담당자 표시 */}
      <div className="flex flex-wrap gap-2">
        {/* {value.length === 0 && (
          <span className="text-sm text-gray-400">{placeholder}</span>
        )} */}

        {value.map((p) => (
          <span
            key={p.id}
            className="flex items-center gap-1 px-2 py-1 text-xs border rounded-md bg-gray-50"
          >
            {p.name || p.user?.name}

            {(p.company && p.department)
              ? ` (${p.company}/${p.department})`
              : ""}

            <button
              onClick={() => removePerson(p.id)}
              className="text-red-500 ml-1 hover:text-red-700"
            >
              ✕
            </button>
          </span>
        ))}
      </div>

      {/* ⭐ single 모드일 때: 사람 1명 선택되면 버튼 숨김 */}
      {!(single && value.length > 0) && (
        <button
          className="btn-basic-sm"
          onClick={() => setOpen(true)}
        >
          담당자 선택
        </button>
      )}

      <ReferenceModal
        isOpen={open}
        onClose={() => setOpen(false)}
        selectedIds={tempSelectedIds}
        name="담당자 선택"
        onChange={(ids) => setTempSelectedIds(ids)}
        onSave={handleSave}
        single={single}
      />
    </div>
  );
}
